import ContainerBox from "myshubhlife-component/container-box";
import * as React from "react";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import SelectBank from "BsPdfUploadV2/components/SelectBank";
import "./style.scss";
import {getInstitutions, requestBsUpload, RequestPath} from "BsPdfUploadV2/api";
import UploadPdf from "BsPdfUploadV2/components/UploadPdf";
import {Button, Loading} from "web-com";
import {AndroidApis} from "app";
import UploadedFiles from "BsPdfUploadV2/components/UploadedFiles";
import Popup from "BsPdfUploadV2/components/Popup";
import {backPopupMessage, bsUploadType, bsVendor, getErrorMessages, getUploadErrors} from "BsPdfUploadV2/utils";
import {getIdToken} from "service";
import {useLocation} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import {updateSubStatuses} from "IncompleteInfoV2/api";
import {pageTitle, ScreenNames} from "IncompleteInfoV2/utils";
import {removeCompletedSubStatus, showToast} from "IncompleteInfoV2/actions";
import {IScreens} from "IncompleteInfoV2/interface";
import {COLOR} from "utils/variables";
import {IReduxState} from "reducers";

interface IConnectProps {
    userId: number;
    dispatch?: (action: any) => void;
    isAndroid: boolean;
    applicationId: number;
    screens: IScreens;
}
interface IState {
    institutionId?: string;
    password?: string;
    files?: string[];
    getStarted?: boolean;
    uploadCompleted?: boolean;
    showUpload?: boolean;
    entityId?: string;
    linkId?: string;
    perfiosTransactionId: string;
    txnId?: string;
    yearMonthFrom?: string;
    yearMonthTo?: string;
    fromDate?: number;
    toDate?: number;
}
const InitialState: IState = {
    institutionId: null,
    password: null,
    files: [],
    getStarted: false,
    uploadCompleted: false,
    showUpload: true,
    entityId: null,
    linkId: null,
    perfiosTransactionId: null,
    txnId: null,
    yearMonthFrom: null,
    yearMonthTo: null,
    fromDate: null,
    toDate: null,
};
const BSPdfUpload = (props: IConnectProps & RouteComponentProps) => {
    const incompleteInfo = "incompleteInfo";
    const urlParams = new URLSearchParams(useLocation().search);
    const invoker = urlParams.get("invoker");
    const [state, setState] = useState<IState>(InitialState);
    const [institutions, setInstitutions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [blockUser, setBlockUser] = useState(false);
    useEffect(() => {
        setLoading(true);
        getInstitutions().then((res) => {
        setLoading(false);
        const bankOptions = res.data.institutions.map((data) => {
             return {
                 name: data.name,
                 value: data.id,
             };
        });
        bankOptions.unshift({name: "Select other Banks", value: ""});
        setInstitutions(bankOptions);
     }).catch((err) => {
        setLoading(false);
     });
    }, []);
    useEffect(() => {
        if (props.isAndroid && blockUser) {
            AndroidApis.showPopUpOnBack({
                title: backPopupMessage.title,
                message: backPopupMessage.desc,
                positiveButtonText: "Yes",
                negativeButtonText: "No",
                enablePopUp: true,
                canGoBack: true,
            });
        }
        return () => {
            if (props.isAndroid && blockUser) {
                AndroidApis.showPopUpOnBack({enablePopUp: false});
            }
        }
    }, [blockUser]);
    const stateUpdate = (newState) => {
        setState((prevState: IState) => {
            return {
                ...prevState,
                ...newState,
            };
        });
    };
    const onUploadClick = (file: string, password: string) => {
        const {institutionId, perfiosTransactionId, entityId, txnId} = state;
        setLoading(true);
        setError(null);
        const reqBody = {
                handler: RequestPath.UPLOAD,
                userId: props.userId,
                institutionId,
                perfiosTransactionId,
                entityId,
                txId: txnId,
                file: `data:application/pdf;base64,${file}`,
                password,
        };
        requestBsUpload(RequestPath.UPLOAD, reqBody).then((res) => {
            setLoading(false);
            if (res.data["status"] !== 1 && res.data["vendor"] === bsVendor.FINBOX) {
                setError(getUploadErrors[res.data.status]);
            } else {
                stateUpdate({files: [...state.files, file], password, showUpload: false});
            }
        }).catch((err) => {
            setLoading(false);
            setError(getErrorMessages(err));
        });
    };
    const onCompleteClick = () => {
        setLoading(true);
        setError(null);
        const {userId} = props;
        const {institutionId, perfiosTransactionId, entityId} = state;
        const reqBody = {
            handler: RequestPath.COMPLETE,
            userId,
            institutionId,
            perfiosTransactionId,
            entityId,
        };
        requestBsUpload(RequestPath.COMPLETE, reqBody).then((res) => {
            setLoading(false);
            if (invoker === incompleteInfo) {
                onSubmit();
            } else {
                stateUpdate({uploadCompleted: true});
            }
        }).catch((err) => {
            setLoading(false);
            setError(getErrorMessages(err));
        });
    };
    const onStartClick = (institutionId: string) => {
        stateUpdate({institutionId});
        setLoading(true);
        setBlockUser(true);
        const version = "1.1";
        const {userId} = props;
        const {fromDate, toDate} = state;
        const reqBody = {
            handler: RequestPath.START,
            fbToken: getIdToken(),
            userId,
            institutionId,
            fromDate,
            toDate,
            version,
        };
        requestBsUpload(RequestPath.START, reqBody).then((res) => {
            setLoading(false);
            const {entityId, linkId, perfiosTransactionId, txnId, yearMonthFrom, yearMonthTo} = res.data;
            stateUpdate({
                entityId,
                linkId,
                perfiosTransactionId,
                txnId,
                yearMonthFrom,
                yearMonthTo,
                getStarted: true,
            });
        }).catch((err) => {
            setLoading(false);
            setError(getErrorMessages(err));
        });
    };
    const clickAddMore = () => stateUpdate({showUpload: true});
    const onSubmit = async () => {
        setState(InitialState);
        setError(null);
        setBlockUser(false);
        try {
            if (invoker === incompleteInfo) {
                setLoading(true);
                if (props.screens[ScreenNames.BANK_STATEMENT]) {
                    const response = await updateSubStatuses(props.applicationId, props.screens[ScreenNames.BANK_STATEMENT].subStatuses);
                    if (response.status === 200) {
                        props.dispatch(showToast(COLOR.GREEN, `${pageTitle.bankStatement} updated successfully`));
                        props.dispatch(removeCompletedSubStatus(ScreenNames.BANK_STATEMENT));
                        setLoading(false);
                        props.history.replace({ pathname: `/incomplete-info`});
                    }
                }
            }
        } catch (err) {
            setLoading(false);
        }
    };
    return(
        <>
            <Loading active={loading} msg={"Please wait.."}/>
            <ContainerBox showBackButton={!props.isAndroid} pageTitle="Bank statement pdf upload">
                {
                    state.uploadCompleted &&
                    <Popup active={state.uploadCompleted}
                           onSubmit={onSubmit}
                           msg="Bank statement submitted successfully"/>
                }
                <div className="bs-pdf-container">
                    <SelectBank options={institutions}
                                disabled={state.getStarted}
                                onStartClick={onStartClick}
                    />
                    {state.getStarted &&
                        <div className="heading">
                            Please upload your salary account bank statement with 3 latest salary credits
                        </div>
                    }
                    {state.files && <UploadedFiles files={state.files}/>}
                    {state.getStarted && state.showUpload && <UploadPdf onClick={onUploadClick}/>}
                    {
                        state.getStarted &&
                        <div className="btn-add-more">
                            <Button buttonText="Add more file"
                                    onClick={clickAddMore}
                                    bgColor="#434175"
                                    height={40}
                                    isDisabled={state.showUpload}
                            />
                        </div>
                    }
                    {error &&
                        <div className="error">
                            <p className="heading">An error has occurred</p>
                            <p className="text-danger">{error}</p>
                        </div>
                    }
                    {state.getStarted &&
                        <div className="btn-complete">
                            <Button buttonText="Complete"
                                    isDisabled={state.files.length === 0}
                                    onClick={onCompleteClick}
                                    size="large"
                                    rounded={true}
                            />
                        </div>
                    }
                </div>
            </ContainerBox>
        </>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth ? state.login.auth.userId : null,
        isAndroid: state.login.isAndroid,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
        screens: state.incompleteInfoV2.screens,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(BSPdfUpload);
